export const SUBSCRIPTION_RULES_TEXTS = {
  // Tab title
  TAB_TITLE: 'Subscription Rules',

  // Table columns
  COLUMN_SUBSCRIPTION_NAME: 'Subscription Name',
  COLUMN_TEMPLATE_NAME: 'Template Name',
  COLUMN_TARGET: 'Target',
  COLUMN_REPEATS_ON: 'Repeats on',
  COLUMN_REPEATS_AT: 'Repeats at',
  COLUMN_END_DATE: 'End Date',
  COLUMN_ACTIVE_SUBSCRIBE: 'Active Subscribe',
  COLUMN_ACTIONS: 'Actions',

  // Empty state
  EMPTY_STATE_TITLE: 'No subscription rules yet',
  EMPTY_STATE_DESCRIPTION: 'Create your first subscription rule to automate report delivery',

  // Buttons
  ADD_NEW_BUTTON: 'Add New Subscription Rule',
  EDIT_TOOLTIP: 'Edit',
  DELETE_TOOLTIP: 'Delete',

  // Dialog
  ADD_DIALOG_TITLE: 'Add New Subscription Rule',
  EDIT_DIALOG_TITLE: 'Edit Subscription Rule',
  SUBSCRIPTION_SETTINGS_TITLE: 'Subscription Settings',
  SUBSCRIPTION_NAME_LABEL: 'Subscription Name',
  SAVE_BUTTON: 'SAVE',
  UPDATE_BUTTON: 'UPDATE',
  ACTIVE_SUBSCRIBE_LABEL: 'Active subscribe',

  // Delete confirmation
  DELETE_DIALOG_TITLE: 'Delete this subscription rule?',
  DELETE_DIALOG_CONTENT: 'If you delete this subscription rule, reports will no longer be delivered automatically.',
  DELETE_DIALOG_CONFIRM: 'Yes, Delete',

  // Validation
  SUBSCRIPTION_NAME_REQUIRED: 'Required',
  SUBSCRIPTION_NAME_UNIQUE: 'Subscription name must be unique',
  REPORT_TEMPLATE_REQUIRED: 'Please select a template',
} as const;
